<template>
  <div class="goodList">
    <el-row :gutter="20" v-show="goodList.length">
      <el-col
        style="width: 20%"
        v-for="(item, index) in goodList"
        :key="item.spuId"
      >
        <div class="good-item cursor-pointer" @click="goDetail(item)">
          <div
            style="position: absolute; left: 10px; top: 20px; z-index: 1"
            v-if="
              getSelectSku(item).tagNameList &&
              getSelectSku(item).tagNameList.length
            "
          >
            <el-tag
              v-for="(itm, index) in getSelectSku(item).tagNameList"
              :key="index"
              size="mini"
              style="margin-right: 3px"
              type="danger"
              effect="dark"
            >
              {{ itm }}
            </el-tag>
          </div>
          <div class="price-tag" v-if="getSelectSku(item).discountRate">
            {{ formartDiscount(getSelectSku(item).discountRate) }}
          </div>
          <el-image
            v-show="getSelectSku(item).fileUrl"
            :src="getSelectSku(item).fileUrl"
            class="goodsImg goodsImg_main"
            fit="contain"
          >
            <template slot="error">
              <img src="~@/assets/img/bitmap.png" class="goodsImg goodsImg_animate" />
            </template>
          </el-image>
          <img
            src="~@/assets/img/bitmap.png"
            v-show="!getSelectSku(item).fileUrl"
            class='goodsImg_animate'
            alt=""
            width="208px"
            height="208px"
          />
          <div class="skuList">
            <div
              class="skuItem"
              @click.stop="skuSelect(item, sku, index, skuIndex)"
              v-for="(sku, skuIndex) in item.skuList.slice(0, 4)"
              :key="sku.skuId"
              :class="{ skuItem_active: (item.activeIndex || 0) == skuIndex }"
            >
              <img :src="sku.fileUrl" v-if="sku.fileUrl" />
              <img src="~@/assets/img/bitmap.png" v-else />
            </div>
            <div
              v-if="item.skuCount > 4"
              @click.stop="goDetail(item)"
              class="skuItemMore"
            >
              <img src="~@/assets/img/good/showMore.png" />
            </div>
          </div>
          <div class="multi_line_overflow good-spu-name line-break">
            {{ getSelectSku(item).skuName }}
          </div>
          <div class="spu-code">商品编码：{{ getSelectSku(item).skuCode }}</div>
          <div class="spu-code">商品型号：{{ getSelectSku(item).model }}</div>
          <div
            class="price price_text"
            v-show="
              (getSelectSku(item).commodityType &&
                getSelectSku(item).commodityType.indexOf('非标') > -1) ||
              getSelectSku(item).isSellingPriceExpire
            "
          >
            待询价
          </div>
          <good-price
            v-show="
              getSelectSku(item).commodityType &&
              getSelectSku(item).commodityType.indexOf('非标') === -1 &&
              !getSelectSku(item).isSellingPriceExpire
            "
            :price="Number(getSelectSku(item).sellingPrice) || 0"
            :losePrice="getSelectSku(item).originPrice || 0"
          ></good-price>
          <!-- 操作 -->
          <div class="operation">
            <div
              class="collect_box"
              :loading="item.loading"
              :class="{ collect_box_active: getSelectSku(item).collected }"
              @click.stop="collectBtn(item)"
            >
              <div class="collect_box_icon">
                <img src="~@/assets/img/good/collect.png" alt="" />
              </div>
              <div
                class="collect_box_text"
                :class="{ collect_box_text_active: getSelectSku(item).collected }"
              >
                已收藏
              </div>
            </div>
            <div
              class="add_cart"
              :loading="item.loading"
              @click.stop="addCart(item, $event)"
            >
              <div class="add_cart_icon">
                <img src="~@/assets/img/good/addCart.png" class="add_cart_icon_animate" alt="" />
              </div>
              <span class="add_cart_text" v-if="getSelectSku(item).commodityType &&
              getSelectSku(item).commodityType.indexOf('非标') === -1 &&
              !getSelectSku(item).isSellingPriceExpire">加入购物车</span>
              <span class="add_cart_text" v-else>加入询价篮</span>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-pagination ref="goodList" style="visibility: hidden; opacity: 0">
    </el-pagination>
  </div>
</template>
<script>
import GoodPrice from '@/components/good-price/goodPrice.vue'
import { getAccessToken } from '@/utils/userInfo'
import { openOther, isElementInViewport } from '@/utils'
import anime from 'animejs' // 引入
import { mul } from "@/utils/numberComputed";

export default {
  data () {
    return {}
  },
  props: {
    goodList: {
      type: Array,
      default: () => {
        return []
      }
    },
    page: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    },
    limit: {
      type: Number,
      default: 20
    },
    premium: {
      type: Boolean,
      default: false
    }
  },
  components: {
    GoodPrice
  },
  mounted () {
    window.addEventListener('scroll', this.lazyLoading) // 滚动到底部，再加载的处理事件
  },
  destroyed () {
    window.removeEventListener('scroll', this.lazyLoading)
  },
  methods: {
     formartDiscount(discountRate) {
      const num = mul(discountRate, 100);
      if (num % 10 === 0) {
        return num / 10 + "折";
      } else {
        return num + "折";
      }
    },
    lazyLoading () {
      if (isElementInViewport(this.$refs.goodList.$el)) {
        if (this.goodList.length >= this.total) return
        this.load()
      }
    },
    load () {
      let current = this.page
      current++
      this.$emit('refushDataList', current)
    },
    pageSizeChangeHandle (val) {},
    // 跳转页
    getDataList (val) {
      this.$emit('refushDataList', val)
    },
    // 跳转详情页
    goDetail (goods) {
      const groupId = goods.skuList.length > 1 ? goods.groupId : ''
      const spuId = goods.skuList[goods.activeIndex || 0].spuId
      const skuId = goods.skuList[goods.activeIndex || 0].skuId
      if (this.premium) {
        openOther(`goodDetail?groupId=${groupId}&spuId=${spuId}&skuId=${skuId}&boutiqueCategoryId=0`)
      } else {
        openOther(`goodDetail?groupId=${groupId}&spuId=${spuId}&skuId=${skuId}`)
      }
    },
    // sku选中
    skuSelect (item, sku, index, skuIndex) {
      item.activeIndex = skuIndex
      this.goodList[index].activeIndex = skuIndex
      console.log(item, sku, skuIndex)
      this.$forceUpdate()
    },
    // 获取选中sku
    getSelectSku (item) {
      return item.skuList[item.activeIndex || 0]
    },
    // 收藏 || 取消收藏
    collectBtn (item) {
      // 未登录
      if (!getAccessToken()) {
        this.$router.push({
          name: 'login'
        })
        return false
      }
      item.loading = true
      const skuId = item.skuList[item.activeIndex || 0].skuId
      const isCollect = !!(item.skuList[item.activeIndex || 0].collected == null || item.skuList[item.activeIndex || 0].collected == false || !item.skuList[item.activeIndex || 0].collected)

      this.$http
        .post(
          `/front/commodity-user/app/${
            isCollect ? 'collect' : 'cancel-collect'
          }/${skuId}`
        )
        .then((res) => {
          console.log(res)
          if (res.data.code == 0) {
            item.skuList[item.activeIndex || 0].collected = isCollect
            this.$message.success('操作成功')
            this.$forceUpdate()
          }
        })
        .catch(() => {})
        .finally(() => {
          item.loading = false
        })
    },
    // 加入购物车
    addCart (goods, event) {
      // 未登录 跳转登录页
      if (!getAccessToken()) {
        this.$router.push({
          name: 'login'
        })
        return false
      }
      if (this.loading) {
        return false
      }
      this.loading = true
      const spuId = goods.skuList[goods.activeIndex || 0].spuId
      const skuId = goods.skuList[goods.activeIndex || 0].skuId
      const custspId = goods.skuList[goods.activeIndex || 0].custspId
      // 购物车类型 ==1 是商品购物车，==2 是询价篮
      let shoppingType = '1'
      if ((goods.skuList[goods.activeIndex || 0].commodityType &&
      goods.skuList[goods.activeIndex || 0].commodityType.indexOf('非标') > -1) ||
      goods.skuList[goods.activeIndex || 0].isSellingPriceExpire) {
        shoppingType = '2'
      }

      // 判断是否是企业站用户
      if (this.$store.state.user.corpUserInfo.customerId) {
        // 添加到企业站购物车
        this.$http.post(`/front/oms/crop-site/shopping-cart/add`,{
          custspId: custspId,
          skuId: skuId,
          goodsNum: 1
        }).then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          
          this.createDraftAnime(goods, event, shoppingType)
          this.$message.success('购物车添加成功')
        })
        .finally(() => {
          this.loading = false
        })
        return
      }
      this.$http
        .post(`/front/consumer/shoppingcart/addShoppingCart`, {
          goodsSpuId: spuId,
          goodsSkuId: skuId,
          goodsNum: 1,
          shoppingType: shoppingType
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.$message.success(
            `${this.$t('product.add')} ${
              shoppingType === '1'
                ? this.$t('product.cart')
                : this.$t('product.blanket')
            } ${this.$t('product.success')}`
          )
          this.createDraftAnime(goods, event, shoppingType)
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 创建动画效果
    createDraftAnime (item, event, shoppingType) {
      // shoppingType 购物车类型 ==1 是商品购物车，==2 是询价篮
      const fileUrl = item.skuList[item.activeIndex || 0].fileUrl
      const goodImage = event.target.parentNode.parentNode.parentNode.querySelector('.el-image__inner') // 获取商品图片
      if(!goodImage){
        return
      }
      const cartIcon = document.getElementById('add_cart_nav') // 获取购物车图标
      const cartIcon1 = document.getElementById('add_inquiry_cart_nav') // 获取询价蓝图标
      // 获取商品图片和购物车的位置
      const startRect = goodImage.getBoundingClientRect()
      const endRect = shoppingType == 1 ? cartIcon.getBoundingClientRect() : cartIcon1.getBoundingClientRect()

      // 创建飞行元素
      const flyImage = document.createElement('img')
      flyImage.src = fileUrl
      flyImage.style.position = 'fixed'
      flyImage.style.width = '200px'
      flyImage.style.height = '200px'
      flyImage.style.left = `${startRect.left}px`
      flyImage.style.top = `${startRect.top}px`
      flyImage.style.zIndex = 9999
      document.body.appendChild(flyImage)

      // 使用 anime.js 实现飞行动画
      anime({
        targets: flyImage,
        left: `${endRect.left}px`,
        top: `${endRect.top}px`,
        width: '20px',
        height: '20px',
        duration: 1000,
        easing: 'easeInOutQuad',
        complete: () => {
          // 通知购物车
          this.$store.dispatch(
            'setShoppingCartCount',
            this.$store.state.shoppingCartCount + 1
          )

          // 动画完成后移除飞行元素
          document.body.removeChild(flyImage)
        }
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.goodList {
  // background: #fff;
  width: 1180px;
  .good-item {
    position: relative;
    margin-top: 3px;
    background: #fff;
    height: 446px;
    width: 230px;
    padding: 10px 0;
    border-radius: 12px;
    background: #ffffff;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06);
    margin-bottom: 10px;
    -webkit-box-shadow: rgba(0, 0, 0, 0.07) 0px 3px 9px 0;
    -moz-box-shadow: rgba(0, 0, 0, 0.07) 0px 3px 9px 0;
    box-shadow: rgba(0, 0, 0, 0.07) 0px 3px 9px 0;
    &:hover {
      -webkit-box-shadow: rgba(0, 0, 0, 0.27) 0px 3px 9px 0;
      -moz-box-shadow: rgba(0, 0, 0, 0.27) 0px 3px 9px 0;
      box-shadow: rgba(0, 0, 0, 0.27) 0px 3px 9px 0;
    }
    .price_text {
      font-size: 18px;
    }
    /deep/ .price {
      margin-top: 0px;
      margin-left: 7px;
      color: #e64c3a;
      font-weight: bold;
      .price-int {
        font-size: 18px;
      }
      .price-point {
        font-size: 10px;
      }
    }
    .good-spu-name {
      height: 34px;
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      line-height: 17px;
      margin: 12px 7px 0;
    }
    .spu-code {
      margin: 2px 7px 0;
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      line-height: 17px;
      width: calc(100% - 14px);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    img {
      object-fit: contain;
    }

    .goodsImg_main {
      margin: 0 0 0 13px;
    }
    .goodsImg {
      width: 204px;
      height: 204px;
      object-fit: contain;
    }

    .skuList {
      display: flex;
      justify-content: flex-start;
      margin-top: 20px;
      width: 100%;
      margin-left: 7px;
      .skuItem {
        width: 40px;
        height: 40px;
        border-radius: 4px;
        opacity: 1;
        box-sizing: border-box;
        border: 1px solid #cccccc;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          display: block;
        }
        margin-right: 3px;
        &:hover {
          border: 1px solid #888281;
        }
      }
      .skuItem_active {
        border: 1px solid #2a54d1;
      }

      .skuItemMore {
        font-weight: 500;
        text-align: center;
        letter-spacing: 0em;
        color: #9e9e9e;
        width: 40px;
        height: 40px;
        border-radius: 4px;
        opacity: 1;
        box-sizing: border-box;
        border: 1px solid #cccccc;
        overflow: hidden;
        &:hover {
          border: 1px solid #888281;
        }
        img {
          width: 80%;
          height: 80%;
          object-fit: contain;
          display: block;
          margin: 10%;
        }
      }
    }
    .operation {
      height: 36px;
      width: 218px;
      overflow: hidden;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 5px;
      margin-left: 7px;
      .collect_box {
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(42, 84, 209, 0.31);
        height: 36px;
        width: 40px;
        cursor: pointer;
        transition: all 0.3s;
        &:hover {
          opacity: 0.8;
        }
        .collect_box_icon {
          width: 18px;
          height: 18px;
          img {
            width: 100%;
            display: block;
          }
        }
        .collect_box_text {
          color: #ffffff;
          font-weight: 500;
          font-size: 16px;
          overflow: hidden;
          width: 0;
          white-space: nowrap;
        }
        .collect_box_text_active {
          width: 50px;
          margin-left: 3px;
        }
      }
      .collect_box_active {
        width: 84px;
        background: #ff4c2b;
      }
      .add_cart {
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: center;
        background: #2a54d1;
        height: 36px;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
        .add_cart_icon {
          width: 18px;
          height: 18px;
          img {
            width: 100%;
            display: block;
          }
        }
        .add_cart_text {
          color: #ffffff;
          font-weight: 500;
          font-size: 16px;
          margin-left: 3px;
        }
      }
    }
  }
}
.price-tag {
  display: inline-block;
  width: 68px;
  height: 26px;
  position: absolute;
  top: 192px;
  left: 6px;
  background-image: url("../../../assets/img/good/price-tag-bg.png");
  color: #fff;
  font-size: 12px;
  text-align: center;
  padding-left: 28px;
  line-height: 26px;
  z-index:10;
}
</style>
